import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, Collapse, IconButton } from '@mui/material';
import clsx from 'clsx';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import makeStyles from '@mui/styles/makeStyles';
import { songs } from './songs';

const useStyles = makeStyles((theme) => ({
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

const TileForSong = ({ song }) => {
  return (
    <div>
      <h2>{song.getTitle()}</h2>
      <p>{song.getLyrics()}</p>
    </div>
  );
};

const CardForSongs = () => {

  const { t } = useTranslation();

  const classes = useStyles();
  const [ isExpanded, setExpanded ] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!isExpanded);
  };

  return (
    <Card className={'card-for-songs'}>
      <CardHeader
        title={t('mutations_in_songs_title')}
        action={
          <IconButton
            className={clsx(classes.expand, {
              [ classes.expandOpen ]: isExpanded,
            })}
            onClick={handleExpandClick}
            aria-expanded={isExpanded}
            aria-label="show more"
            size="large">
            <ExpandMoreIcon />
          </IconButton>
        } />
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <CardContent className={'layout-for-songs'}>
          {songs.map((song, idx) => (<TileForSong key={idx} song={song} />))}
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default memo(CardForSongs);

